class QueryParameters {
  private params: { [p: string]: string }
  constructor() {
    const querystring = window.location.search.substring(1);
    if (querystring.length === 0) {
      this.params = {}
    } else {
      this.params = querystring.split('&').reduce((result: {
        [key: string]: string
      }, cur: string) => {
        result[cur.split('=')[0]] = cur.split('=')[1]
        return result
      }, {})
    }
  }

  set(parameter: string, value: string): QueryParameters {
    this.params[parameter] = value
    return this
  }

  unset(parameter: string): QueryParameters {
    delete this.params[parameter]
    return this
  }

  has(parameter: string): boolean {
    return this.params.hasOwnProperty(parameter)
  }

  get(parameter: string): string {
    return this.params[parameter]
  }

  getQueryString(): string {
    const { params } = this
    const keys = Object.keys(params);
    if (keys.length === 0) {
      return '';
    }
    return '?' + keys.reduce((result: Array<string>, key: string) => {
      result.push([key, params[key]].join('='))
      return result
    }, []).join('&')
  }
}

export default QueryParameters
